import { RootState } from "../store/combineReducer";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import NavBar from "../components/others/NavBar/NavBar";
import SideBar from "../components/others/SideBar/SideBar";
import AtendooWidget from "../components/others/AtendooWidget/AtendooWidget";
import { useState, useEffect } from "react";
import { useSyncMockBillingPolicy } from "../hooks/useSyncMockBillingPolicy";

export default function LayoutBase() {
  const { reduceSideBar } = useSelector((state: RootState) => state.app);
  useSyncMockBillingPolicy();
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Detectar si estamos en mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Cerrar sidebar al cambiar a desktop
  useEffect(() => {
    if (!isMobile) {
      setIsMobileSidebarOpen(false);
    }
  }, [isMobile]);

  // Prevenir scroll del body cuando el sidebar está abierto en mobile
  useEffect(() => {
    if (isMobile && isMobileSidebarOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobile, isMobileSidebarOpen]);

  const toggleMobileSidebar = () => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen);
  };

  const closeMobileSidebar = () => {
    setIsMobileSidebarOpen(false);
  };

  return (
    <div className="main-layout">
      {/* Overlay para mobile */}
      {isMobile && isMobileSidebarOpen && (
        <div
          className="mobile-overlay"
          onClick={closeMobileSidebar}
        />
      )}

      {/* Sidebar */}
      <SideBar
        isMobileOpen={isMobileSidebarOpen}
        onMobileClose={closeMobileSidebar}
        isMobile={isMobile}
      />

      <AtendooWidget />
      <div className="main-content">
        <NavBar onMobileMenuToggle={toggleMobileSidebar} />
        <div className="content-area">
          <Outlet />
        </div>
      </div>
    </div>
  );
}